export const emptyAuditEvent = {
  id: '',
  resource_type: '',
  resource_id: '',
  action: '',
  timestamp: '',
  status: '',
  error_message: null,
  data: '{}',
  description: '',
  user: { id: '' },
  tenant: { id: '' },
  account: { id: '' },
  principal_type: '',
  client_ip: ''
}
